import type { ResponseWithFacetsDto } from '@/features/shared/data/algolia/algolia-base.dto.ts'
import { mapFiltersToAlgoliaFilters } from '@/features/shared/data/mappers/mapFiltersToAlgoliaFilters.ts'
import algoliaClient from '../../shared/data/algolia/algolia-client.ts'
import type { SoundEffectDto, SoundEffectFacets } from './sound-effect.dto.ts'
import { algoliaIndex } from '@/logic/configuration.ts'

export const SoundEffectService = {
  getSoundEffects: async (
    page: number,
    pageSize: number,
    searchTerm: string | undefined,
    filters: { tags: string[] }
  ): Promise<ResponseWithFacetsDto<SoundEffectDto, SoundEffectFacets>> => {
    const { tags = [] } = filters
    const response = await algoliaClient().searchSingleIndex<SoundEffectDto>({
      indexName: algoliaIndex.soundEffect,
      searchParams: {
        query: searchTerm ?? '',
        hitsPerPage: pageSize,
        page,
        filters: mapFiltersToAlgoliaFilters({
          'labels.as.category.display_values': tags,
        }),
        maxValuesPerFacet: 200,
        analytics: true,
        distinct: true,
        facets: ['labels.as.category.display_values'],
      },
    })
    const { facets, ...rest } = response
    return {
      ...rest,
      facets: facets ?? {},
    } satisfies ResponseWithFacetsDto<SoundEffectDto, SoundEffectFacets>
  },
}
